"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideModal = exports.showModal = void 0;
var SHOW_MODAL = 'SHOW_MODAL';
var HIDE_MODAL = 'HIDE_MODAL';

var showModal = function showModal(id, props) {
  return {
    type: SHOW_MODAL,
    payload: {
      id: id,
      props: props
    }
  };
};

exports.showModal = showModal;

var hideModal = function hideModal() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: HIDE_MODAL,
    payload: {
      id: id
    }
  };
};

exports.hideModal = hideModal;